/**
 * Sport landing carousels — prev/next buttons for a scroll-snap track.
 * Markup: [data-sport-carousel] > [data-sport-carousel-track] + [data-sport-carousel-prev|next]
 * Swiping / trackpad scrolling works without this; it only drives the arrow buttons.
 */
(function () {
  function init(root) {
    if (root.dataset.sportCarouselReady) return;
    var track = root.querySelector('[data-sport-carousel-track]');
    var prev = root.querySelector('[data-sport-carousel-prev]');
    var next = root.querySelector('[data-sport-carousel-next]');
    if (!track || !prev || !next) return;
    root.dataset.sportCarouselReady = 'true';

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
      root.classList.toggle('sport-carousel--static', max <= 0);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sport-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
